import React, {useState} from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import {TextField, Snackbar, Alert} from "@mui/material";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import {useNavigate} from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { db } from "../../FireBase/firestore";
import { collection, query, where, getDocs } from "firebase/firestore";

const LoginForm = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const isTablet = window.innerWidth >= 768 && window.innerWidth <= 834;
    const isMobile = window.innerWidth <= 440;
    const [snackbar, setSnackbar] = useState({open:false, severity:'success', message:''});
    const showMessage = (severity,message)=>{
        setSnackbar({
            open:true,
            severity,
            message
        })
    }
    const handleCloseSnackbar = ()=>{setSnackbar({...snackbar,open:false})}
    const handleLogin = async () => {
        if(!email.trim()){
            showMessage("error","Please enter your email");
            return;
        }
        if(!password.trim()){
            showMessage("error","Please enter your password");
            return;
        }
        try{
            setLoading(true);
            const q = query(
                collection(db,"users"),
                where("email","==",email),
                where("password","==",password)
            );
            const querySnapshot = await getDocs(q);
            setLoading(false);
            if(!querySnapshot.empty){
                const userData = querySnapshot.docs[0].data();
                localStorage.setItem("loggedInUser", JSON.stringify(userData));
                showMessage("success","Login Successfully");
                setTimeout(()=>{
                    navigate("/");
                },2000)
            }else{
                showMessage("error","Invalid Email or Password");
            }
        }catch(error){
            setLoading(false);
            showMessage("error",error.message);
        }

    }

    return (
        <div className="bg-offWhite p-0">
            <NavBar/>
            <div style={{ paddingTop: isMobile ? "4rem" : isTablet ? "0" : "7rem"}}>
                <Container className="d-flex justify-content-center align-items-center min-vh-100">
                    <Row className="w-100 justify-content-center">
                        <Col md={12} lg={5}>
                            <div className="p-4 shadow" style={{ backgroundColor: '#fff', borderRadius: '20px' }}>
                                <div className="d-flex justify-content-center">
                                    <h2 className="text-green fw-bold pt-3">LOGIN</h2>
                                </div>
                                <Col>
                                    <Col lg={12} className="mb-4 mt-5">
                                        <TextField label="E-mail*" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-100"/>
                                    </Col>
                                    <Col lg={12} className="mb-4">
                                        <TextField label="Password*" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-100"/>
                                    </Col>
                                    <div className="text-end mb-3">
                                        <a className="text-green small" style={{ cursor: "pointer" }} onClick={() => navigate("/forgot-password")}>Forgot Password</a>
                                    </div>
                                    <Button style={{ backgroundColor: '#A6CE3A', borderColor: '#A6CE3A' }} className="w-100 rounded-pill fw-bold text-white" onClick={handleLogin} disabled={loading}>
                                        {loading ? <CircularProgress size={24} color="inherit"/> : "LOGIN"}
                                    </Button>
                                    <div className="text-center my-3">
                                        <h5 className="text-green fw-bold">OR</h5>
                                    </div>
                                    <Button style={{ backgroundColor: '#A6CE3A', borderColor: '#A6CE3A' }} className="w-100 rounded-pill fw-bold text-white" onClick={()=>navigate('/create-account')}>
                                        CREATE ACCOUNT
                                    </Button>
                                </Col>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer/>
            </div>
            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} variant="filled" sx={{ width: '100%' }}>{snackbar.message}</Alert>
            </Snackbar>
        </div>
    );
};
export default LoginForm;